import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TdoUserGroupConfigurationModel} from '../../../models/configuration/user/tdo-user-group-configuration.model';
import {TaskManagementDetailDialogModel} from '../task-management-dialog/task-management-dialog.component';

@Component({
  selector: 'app-task-user-group-selection-dialog',
  templateUrl: './task-user-group-selection-dialog.component.html',
  styleUrls: ['./task-user-group-selection-dialog.component.scss']
})
export class TaskUserGroupSelectionDialogComponent implements OnInit {
  selectedUserGroup: TdoUserGroupConfigurationModel;
  hoveredItem: TdoUserGroupConfigurationModel;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TaskManagementDetailDialogModel,
              private dialogRef: MatDialogRef<TaskUserGroupSelectionDialogComponent>) {
    //
    if (data.model.ForUserGroupID) {
      const group = data.userGroups.find(p => p.UserGroupId === data.model.ForUserGroupID);
      if (group) {
        this.selectedUserGroup = group;
      }
    }
  }

  ngOnInit(): void {
    //
  }

  close() {
    this.dialogRef.close(this.selectedUserGroup.UserGroupId);
  }

  cancel() {
    this.dialogRef.close();
  }

  onUserGroupSelected(group: TdoUserGroupConfigurationModel) {
    if (this.selectedUserGroup === group) {
      this.selectedUserGroup = null;
    } else {
      this.selectedUserGroup = group;
    }
  }

  onMouseOver(group: TdoUserGroupConfigurationModel) {
    this.hoveredItem = group;
  }

  onMouseOut(group: TdoUserGroupConfigurationModel) {
    this.hoveredItem = null;
  }
}
